export default "__VITE_ASSET__BLmgZYTP__"